import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config.jsx";
import { jobOrderStatuses as fallbackStatuses } from "./dashboardData";
import DashIcon from "./DashIcon";

const JobOrderStatusCard = () => {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const fetchJobStatusData = async () => {
      const token = Cookies.get('token');
      const user_id = Cookies.get('flexichain_user_id');
      try {
        const response = await fetch(`${adminMainUrl}/api/operation-dashboard-job-order-status-data?filter=${filter}`, {
          method: "GET",
          headers: {
            'auth-token': token || '',
            'Authorization': token ? (token.startsWith('Bearer ') ? token : `Bearer ${token}`) : '',
            'user_id': user_id || '',
            'user-id': user_id || '',
            'Content-Type': 'application/json',
          }
        });
        const resData = await response.json();
        if (response.ok && resData?.code === 200) {
          setData(resData.data);
        }
      } catch (err) {
        console.error("Error fetching job order status data:", err);
      }
    };

    fetchJobStatusData();
  }, [filter]);

  let statuses = fallbackStatuses;
  if (data) {
    const rawData = [
      { label: "New", count: data.newJobs || 0, color: "#2563EB" },
      { label: "In Progress", count: data.inProgress || 0, color: "#16A34A" },
      { label: "Pending Customer", count: data.pendingCustomer || 0, color: "#EA580C" },
      { label: "In Transit", count: data.inTransit || 0, color: "#8B5CF6" },
      { label: "Ready to Close", count: data.readyToClose || 0, color: "#D97706" },
      { label: "Closed", count: data.closed || 0, color: "#94A3B8" },
    ];

    const calculatedTotal = rawData.reduce((acc, s) => acc + s.count, 0);

    statuses = rawData.map(s => ({
      ...s,
      percent: calculatedTotal > 0 ? Math.round((s.count / calculatedTotal) * 100) : 0
    }));
  }

  const total = statuses.reduce((acc, s) => acc + s.count, 0);

  return (
    <div className="ops-card ops-job-status-card">
      {/* Header */}
      <div className="ops-card-header">
        <div className="ops-card-heading">
          <span className="ops-card-heading-icon ops-heading-jobs">
            <DashIcon type="briefcase" size={17} color="#fff" />
          </span>
          <span className="ops-card-title">Job Order Status</span>
        </div>
        <select
          className="ops-dropdown"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value="all">All</option>
          <option value="this_week">This Week</option>
          <option value="last_week">Last Week</option>
          <option value="this_month">This Month</option>
        </select>
      </div>

      <div className="ops-job-body">
        {/* Donut Chart */}
        <div className="ops-job-donut-wrap">
          <ResponsiveContainer width={180} height={180}>
            <PieChart>
              <Pie
                data={statuses}
                dataKey="count"
                nameKey="label"
                cx="50%"
                cy="50%"
                innerRadius={58}
                outerRadius={82}
                paddingAngle={2}
                startAngle={90}
                endAngle={-270}
              >
                {statuses.map((entry) => (
                  <Cell key={entry.label} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value, name) => [`${value}`, name]}
                contentStyle={{
                  borderRadius: 8,
                  border: "1px solid #E2E8F0",
                  fontSize: 12,
                }}
              />
            </PieChart>
          </ResponsiveContainer>
          {/* Center label */}
          <div className="ops-donut-center">
            <span className="ops-donut-total">{total}</span>
            <span className="ops-donut-label">Total Jobs</span>
          </div>
        </div>

        {/* Legend */}
        <div className="ops-job-legend">
          {statuses.map((s) => (
            <div key={s.label} className="ops-job-legend-row">
              <div className="ops-job-legend-left">
                <span
                  className="ops-job-legend-dot"
                  style={{ background: s.color }}
                />
                <span className="ops-job-legend-name">{s.label}</span>
              </div>
              <span className="ops-job-legend-count">
                {s.count}&nbsp;
                <span className="ops-job-legend-pct">({s.percent}%)</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobOrderStatusCard;
